"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var json_1 = require("../../common/helpers/json");
var book_class_controller_1 = __importDefault(require("./book-class.controller"));
var book_class_html_1 = __importDefault(require("./book-class.html"));
function getStudent(UserService, $stateParams, UsersModel) {
    var currentUser = UserService.getCurrentUser();
    return UsersModel.getStudentByID(currentUser.id).then(function (response) {
        return response;
    });
}
getStudent.$inject = ["UserService", "$stateParams", "UsersModel"];
function getClassDate($stateParams, CoursesModel) {
    return CoursesModel.getClassDate($stateParams.course_id, $stateParams.class_id).then(function (response) {
        if ((0, json_1.isJson)(response.class.course.location.address)) {
            response.class.course.location.address = JSON.parse(response.class.course.location.address);
        }
        return response.class;
    });
}
getClassDate.$inject = ["$stateParams", "CoursesModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.student.book-class", {
        url: "/{course_id}/{class_id}/book-class",
        controller: book_class_controller_1.default,
        controllerAs: "vm",
        template: book_class_html_1.default,
        resolve: {
            student: getStudent,
            classDate: getClassDate,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.student,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("student.book-class", [])
    .config(config)
    .controller("StudentBookClassController", book_class_controller_1.default);
